<script lang="ts" setup>
    import { LoaderCircle } from 'lucide-vue-next';
    import { useI18n } from 'vue-i18n';
    import { type HTMLAttributes, computed } from 'vue';
    import { cn } from '@/lib/utils';

    const props = withDefaults(
        defineProps<{
            size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
            class?: HTMLAttributes['class'];
        }>(),
        {
            size: 'md',
        },
    );

    const { t } = useI18n();

    const size = computed(() => {
        return {
            xs: 'max-h-20',
            sm: 'max-h-32',
            md: 'max-h-52',
            lg: 'max-h-64',
            xl: 'max-h-80',
        }[props.size];
    });
</script>

<template>
    <div :class="cn('flex h-full items-center justify-center p-4', size, props.class)">
        <span class="flex items-center justify-center gap-2 text-xs">
            <LoaderCircle class="text-primary size-5 animate-spin" />
            {{ t('datatables.loading') }}
        </span>
    </div>
</template>
